import { useCompanyConfiguration } from 'init/use-company-configuration';
import { first, isNullish } from 'remeda';
import { Connector, Integration } from 'shared/components/Integrations/Integrations.constants';

// These are the magic values that qualify a third-party integration as a "connector" in the context of this feature.
// See card RCVR-152 for discussion.
const CONNECTORS = Object.values(Connector) as Array<string>;

// Name misleading, this checks whether:
// - either a connector is active
// - OR: an integration is active, AND reconciliation is done on their end.
// We use this check to disable the manual creation of resources like invoices and payments
// which would lead to incoherent states once that same info is synced from the connector  or integrator.
export const useIsConnectorActive = (): boolean => {
  const company = useCompanyConfiguration();

  // Most restrictive option if constants aren't loaded
  if (company == null) return true;

  const integrationsInUse = company.tp_accounting.integration_in_use;
  const maybeIntegrationInUse = first(integrationsInUse);

  if (maybeIntegrationInUse == null) return false;

  return CONNECTORS.includes(maybeIntegrationInUse) || company.tp_accounting.use_payment_matching;
};

export const useCanSendTermsWithInvoices = (): boolean => {
  const company = useCompanyConfiguration();
  const integrationInUse = first(company.tp_accounting.integration_in_use);

  if (isNullish(integrationInUse)) return true;

  return integrationInUse === Integration.YUKI || CONNECTORS.includes(integrationInUse);
};

export const useCanUseManualActions = (): boolean => {
  const company = useCompanyConfiguration();
  const hasActiveConnector = useIsConnectorActive();

  if (hasActiveConnector) return false;

  return company.package.can_use_manual_actions;
};
